export default "./images/survio-X0LgF-assets-semantic_differential.png";